import type { ReactElement, MouseEvent } from "react";

import { PlainTooltip, ScrollArea } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { OnboardingHubTasksProps } from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubTasks/OnboardingHubTasks";
import { StyledOnboardingHubContentBodyWrapper } from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/containers/styles";
import type { OnboardingGoalQuestionType } from "app/pages/sales-intelligence/sub-modules/onboarding/types/enums";
import { SidebarHubTaskStatus } from "app/pages/sales-intelligence/sub-modules/onboarding/types/SidebarHub";

import {
    LetsGoButton,
    StyledOnboardingHubCard,
    StyledOnboardingHubCardHeader,
    StyledOnboardingHubCardTitle,
    StyledOnboardingHubOrderSpan,
} from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubCard/styles";

import { StyledOnboardingHubContentBody, StyledOnboardingHubContentSmallDescription } from "./styles";
interface OnboardingHubTasksInSidebarProps extends OnboardingHubTasksProps {
    isHubActive: boolean;
}

const OnboardingHubTasksInSidebar = ({
    tasks,
    handleTaskState,
    isHubActive,
}: OnboardingHubTasksInSidebarProps): ReactElement => {
    const handleCardClick = (
        e: MouseEvent<HTMLDivElement>,
        taskType: OnboardingGoalQuestionType,
        taskNumber: number,
    ) => {
        if (isHubActive) {
            e.stopPropagation();
        }
        handleTaskState(true, taskType, true, taskNumber);
    };
    return (
        <StyledOnboardingHubContentBodyWrapper isInSidebar={true}>
            {tasks.length > 0 ? <I18n
                    translatable={{ key: "si.onboarding.hub.recommended-next-steps" }}
                    element={StyledOnboardingHubContentSmallDescription}
                /> : null}
            <ScrollArea
                verticalScrollbarStyle={{ borderRadius: 4, width: 8 }}
                smoothScrolling
                minScrollSize={40}
            >
                <StyledOnboardingHubContentBody isInSidebar={true}>
                    {tasks
                        .filter((task) => task.status !== SidebarHubTaskStatus.Completed)
                        .slice(0, 2)
                        .map((task, index) => (
                            <StyledOnboardingHubCard
                                key={`sidebar-${task.taskType}`}
                                isExpanded={false}
                                isDone={false}
                                isInSidebar={true}
                                data-automation="sidebar-onboarding-hub-task-card"
                                onClick={(e) => handleCardClick(e, task.taskType, index)}
                            >
                                <StyledOnboardingHubCardHeader isInSidebar={true}>
                                    <StyledOnboardingHubOrderSpan>{index + 1} </StyledOnboardingHubOrderSpan>
                                    <StyledOnboardingHubCardTitle
                                        isDone={false}
                                        isInSidebar={true}
                                    >
                                        {translate(`si.onboarding.hub.card.title.${task.taskType}`)}
                                    </StyledOnboardingHubCardTitle>
                                    <PlainTooltip
                                        key="lets-go-button"
                                        placement="top"
                                        tooltipContent={translate("si.onboarding.tooltip.lets-go-button.label")}
                                    >
                                        <div>
                                            <LetsGoButton
                                                type="flat"
                                                iconName="arrow-right"
                                                iconSize="xs"
                                                isExpanded={isHubActive}
                                                isInSidebar={true}
                                            />
                                        </div>
                                    </PlainTooltip>
                                </StyledOnboardingHubCardHeader>
                            </StyledOnboardingHubCard>
                        ))}
                </StyledOnboardingHubContentBody>
            </ScrollArea>
        </StyledOnboardingHubContentBodyWrapper>
    );
};

export default OnboardingHubTasksInSidebar;
